<template>
  <div>
    <InstitucionalHeaderSingle :title="`${$t('baseDadosNacional.cabecalhoTitulo') }`" :classProp="'header-single header-rede-nacional'" />
    <div class="container">
      <div class="row">
        <div class="col-sm col-lg-10 pt-5 ">

          <h2 class="laranja">{{ $t('baseDadosNacional.titulo1') }}</h2>
          <p>{{ $t('baseDadosNacional.paragrafo1') }}</p>
          <p>{{ $t('baseDadosNacional.paragrafo2') }}</p>
        </div>

        <div class="col-sm col-lg-10 pt-5 politica-de-dados">

          <h2 class="laranja">{{ $t('baseDadosNacional.titulo2') }}</h2>

          <p>{{ $t('baseDadosNacional.paragrafo22') }}</p>

          <h2 class="laranja">{{ $t('baseDadosNacional.titulo3') }}</h2>

          <p>{{ $t('baseDadosNacional.paragrafo3') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo4') }}<strong>{{ $t('baseDadosNacional.strong1') }}</strong>{{ $t('baseDadosNacional.paragrafo4b') }}<strong>{{ $t('baseDadosNacional.strong11') }}</strong>{{ $t('baseDadosNacional.paragrafo4c') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo5') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo6') }}</p>

          <h2 class="laranja mb-5" id="como">{{ $t('baseDadosNacional.titulo4') }}</h2>

          <p>{{ $t('baseDadosNacional.paragrafo66') }}<em>{{ $t('baseDadosNacional.strong2') }}</em>{{ $t('baseDadosNacional.paragrafo66b') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo7') }}<em>{{ $t('baseDadosNacional.strong22') }}</em>{{ $t('baseDadosNacional.paragrafo7b') }}<em>{{ $t('baseDadosNacional.strong222') }}</em>{{ $t('baseDadosNacional.paragrafo7c') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo8') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo9') }}</p>

          <p>{{ $t('baseDadosNacional.paragrafo10') }}<strong>{{ $t('baseDadosNacional.strong3') }}</strong>{{ $t('baseDadosNacional.paragrafo10b') }}</p>

          <ol>
            <li>{{ $t('baseDadosNacional.li1') }}</li>
              <ol>
                <li>{{ $t('baseDadosNacional.li2') }}</li>
                <li>{{ $t('baseDadosNacional.li3') }}</li>
                <li>{{ $t('baseDadosNacional.li4') }}</li>
              </ol>
            <li>{{ $t('baseDadosNacional.li5') }}</li>
            <li>{{ $t('baseDadosNacional.li6') }}</li>
            <li>{{ $t('baseDadosNacional.li7') }}</li>
            <li>{{ $t('baseDadosNacional.li8') }}</li>
          </ol>

        </div>
      </div>
    </div>
    <InstitucionalParceiros/>
  </div>
</template>

<script>
import InstitucionalHeaderSingle from '@/components/institucional/InstitucionalHeaderSingle'
import InstitucionalParceiros from '@/components/institucional/InstitucionalParceiros'
export default {
  name: 'BaseDadosNacional',
  components: { InstitucionalHeaderSingle, InstitucionalParceiros }
}
</script>
